export default "__VITE_ASSET__Bic09QDD__"